/* eslint-env browser */
import newPricingpage from './new-pricing';

const pages = [newPricingpage];

export default function register() {
  pages.forEach(page => page());
}



// WEBPACK FOOTER //
// ./src/pages/ab-variants/client.js